import { classNames } from "../../../utils/classNames";
import React, { FC } from "react";
import DocumentTitle from "react-document-title";
import { RouteComponentProps } from "react-router-dom";
import { FontIcon } from "react-toolbox/lib/font_icon";

import style from "./style.scss";

export interface PricingStateProps { }

export interface PricingDispatchProps { }

export interface PricingOwnProps extends RouteComponentProps<any> { }

export type PricingProps = PricingStateProps & PricingDispatchProps & PricingOwnProps;

const PricingLivestream: FC<PricingProps> = () => {
    const __SUPPORT_EMAIL__ = window?.xaStudioConfig?.supportEmail;
    return (
        <DocumentTitle title="XAPP | Radio Pricing">
            <div className={style.pagebg}>
                <header className={style.header}>
                    <h2>Pricing</h2>
                </header>

                <div className={style.planwrap}>
                    <div className={style.plancontainer}>
                        <div className={style.planheader}>
                            <h2>VOICE RADIO</h2>
                            <p>$69.99 setup fee</p>
                            <p>$69.99/month</p>
                        </div>
                        <div className={style.plandetails}>
                            <ul>
                                <li>Live stream</li>
                                <li>Custom welcome message</li>
                                <li>
                                    $49.99 setup fee + $49.99/month <span>for each additional app</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className={classNames(style.plancontainer, style.recommended)}>
                        <div className={classNames(style.planheader, style.pro)}>
                            <h2>VOICE RADIO PRO</h2>
                            <p>$99.99 setup fee</p>
                            <p>$99.99/month</p>

                            <div className={style.value}>
                                <FontIcon value="stars" className={style.valueicon} />
                                <small>Best Value</small>
                            </div>
                        </div>
                        <div className={style.plandetails}>
                            <ul>
                                <li>Everything from Voice Radio</li>
                                <li>Branded Amazon Alexa account</li>
                                <li>Real-time analytics access</li>
                                <li>
                                    $69.99 setup fee + $69.99/month <span>for each additional app</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className={style.plancontainer}>
                        <div className={style.planheader}>
                            <h2>VOICE RADIO PRO+</h2>
                            <p>Custom Pricing for 10+ Stations</p>
                        </div>
                        <div className={style.plandetails}>
                            <ul>
                                <li>Everything from Voice Radio &amp; Voice Radio Pro</li>
                                <li>Other custom features</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <footer className={style.footer}>
                    <p>XAPP is the only company delivering Alexa skills for radio at scale today.</p>
                    <p>
                        If you have any questions or are interested in changing your current subscription, please don't
                        hesitate to <a href={`mailto:${__SUPPORT_EMAIL__}`}>contact us</a>.
                    </p>
                </footer>
            </div>
        </DocumentTitle>
    );
};

export default PricingLivestream;
